module.exports = __webpack_public_path__ + "static/media/gris.3fe5b35b.mp3";